import React, { useState } from 'react';
import IntlMessages from 'Util/IntlMessages';
import icInfo from 'Assets/img/ic_info_16_subtle@2x.png';
import icArrowDown from 'Assets/img/ic_arrow_down_16_basic@2x.png';
import icArrowUp from 'Assets/img/ic_arrow_up_16_primary@2x.png';

const Notice = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className='customer-support-chat-notice'>
      <div className='customer-support-chat-notice-wrapper-content'>
        <div className='customer-support-chat-notice-wrapper-content-icon'>
          <img src={icInfo} alt='info' style={{ width: '16px', height: '16px' }} />
        </div>
        <div className='customer-support-chat-notice-wrapper-content-text'>
          <div>
            <IntlMessages id='customer.support.chat.notice.phone' />
          </div>
          {isOpen && (
            <div>
              <IntlMessages id='customer.support.chat.notice.time' />
            </div>
          )}
        </div>
      </div>
      <div>
        <img className='cursor-pointer' src={isOpen ? icArrowUp : icArrowDown} alt='arrow' style={{ width: '16px', height: '16px' }} onClick={() => setIsOpen(!isOpen)} />
      </div>
    </div>
  );
};

export default Notice;
